import styled from 'styled-components'

import theme, { rem } from '../../../utils/theme'

const StyledHeader = styled.div`
  width: 100%;
  position: relative;
`

const StyledMain = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: ${rem(42)};
  padding: 0 ${rem(8)};
  background-color: ${theme.colors.white};

  .view-mobile & {
    height: ${rem(36)};
  }
`

const StyledPlaceholder = styled.div`
  border-radius: 4px;
  background-color: ${theme.colors.midGrey};
`
/* eslint-disable-next-line no-unused-vars */
// biome-ignore lint/correctness/noUnusedVariables: TODO
const StyledFormLogo = styled.img`
  display: block;
  width: auto;
  max-height: ${rem(28)};

  .view-mobile & {
    max-height: ${rem(22)};
  }
`

const StyledLogoPlaceholder = styled(StyledPlaceholder)`
  width: ${rem(46)};
  height: ${rem(28)};
  border-radius: 4px;
  background-color: ${theme.colors.midGrey};

  .view-mobile & {
    width: ${rem(28)};
    height: ${rem(22)};
  }
`

const StyledTitle = styled.div`
  position: absolute;
  top: ${rem(14)};
  left: 50%;
  width: 40%;
  max-width: ${rem(220)};
  height: ${rem(14)};
  transform: translateX(-50%);
  border-radius: 4px;
  background-color: ${theme.colors.midGrey};

  .view-mobile & {
    top: ${rem(47)};
    width: 100%;
    height: ${rem(8)};
    max-width: ${rem(205)};
  }
`

const StyledOrgUser = styled.div`
  display: flex;
`

const StyledUserPlaceholder = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: center;
  margin-right: ${rem(9)};

  > i {
    background-color: ${theme.colors.midGrey};

    &:nth-child(1) {
      width: ${rem(40)};
      height: ${rem(4)};
      margin: 0 0 ${rem(4)};
      border-radius: ${rem(2)};
    }

    &:nth-child(2) {
      width: ${rem(52)};
      height: ${rem(6)};
      border-radius: ${rem(3)};
    }

    .view-mobile & {
      &:nth-child(1) {
        width: ${rem(21)};
        height: ${rem(3)};
      }

      &:nth-child(2) {
        width: ${rem(28)};
        height: ${rem(4)};
        border-radius: ${rem(2)};
      }
    }
  }
`

const StyledOrgLogo = styled.img`
  display: block;
  width: auto;
  max-height: ${rem(28)};

  .view-mobile & {
    max-height: ${rem(20)};
  }
`

const Header = ({ logo, navLogo, type }) => (
  <StyledHeader>
    <StyledMain>
      {navLogo ? <StyledOrgLogo src={navLogo} /> : type === 'membership' ? <StyledLogoPlaceholder /> : null}
      <StyledTitle />
      {type === 'event' ? (
        <div />
      ) : (
        <StyledOrgUser>
          <StyledUserPlaceholder>
            <i />
            <i />
          </StyledUserPlaceholder>
        </StyledOrgUser>
      )}
      {logo ? <StyledOrgLogo src={logo} /> : <StyledLogoPlaceholder />}
    </StyledMain>
  </StyledHeader>
)

export default Header
